/**
 * Owner display name — a device-local display preference, same category as
 * `src/ui/shared/tokens/theme.ts` (NOT domain event-log data; never synced,
 * never appended to the event log). Mirrors that module's exact shape: a
 * small localStorage-backed function pair plus a change event for
 * cross-component sync, so a future settings-adjacent component can read the
 * live value without a shared context/provider, exactly like
 * `ThemeIndicatorDot` does for `THEME_CHANGE_EVENT`.
 *
 * Used by the Dashboard header greeting ("Good afternoon, {name}.") and the
 * Settings screen's Preferences section. Empty string is the default — the
 * greeting degrades gracefully to "Good afternoon." with no name, never
 * "Good afternoon, undefined."
 */

const STORAGE_KEY = 'compass:owner-name';

export const OWNER_NAME_CHANGE_EVENT = 'compass:owner-name-change';

export function getStoredOwnerName(): string {
  if (typeof window === 'undefined') return '';
  return window.localStorage?.getItem(STORAGE_KEY) ?? '';
}

export function setOwnerName(name: string): void {
  if (typeof window === 'undefined') return;
  const trimmed = name.trim();
  if (trimmed.length === 0) {
    window.localStorage?.removeItem(STORAGE_KEY);
  } else {
    window.localStorage?.setItem(STORAGE_KEY, trimmed);
  }
  window.dispatchEvent(new CustomEvent(OWNER_NAME_CHANGE_EVENT, { detail: trimmed }));
}
